/**
 *  @file       error-codes.js
 *              Wallet API error codes
 *
 *  @author     Ryan Rossiter  - ryan@kingsds.network, 
 *              David Courtis - david@distributive.network
 *  @date       April 2020
 */

Object.assign(exports, {
  unlockFailErrorCode: 'DCP_WA:UNLOCKX',
});
Object.assign(exports, {
  malformedObjectErrorCode: 'DCP_WA:MALFORMED',
});
